export default "__VITE_ASSET__REb0kGTb__"